// extracted by mini-css-extract-plugin
export var border = "_t-8";
export var brand = "_t-t";
export var button = "_t-l";
export var center = "_t-a";
export var centered = "_t-6";
export var closeButton = "_t-c";
export var disabledWrapper = "_t-m";
export var error = "_t-p";
export var extraLarge = "_t-4";
export var extraSmall = "_t-1";
export var fill = "_t-i";
export var footer = "_t-h";
export var footerAction = "_t-j";
export var footerButtons = "_t-k";
export var header = "_t-7";
export var headerWithClose = "_t-d";
export var icon = "_t-o";
export var info = "_t-s";
export var inline = "_t-9";
export var large = "_t-3";
export var main = "_t-e";
export var modal = "_t-0";
export var nearFull = "_t-5";
export var neutral = "_t-u";
export var noPadding = "_t-g";
export var none = "_t-v";
export var scrollable = "_t-f";
export var small = "_t-2";
export var success = "_t-r";
export var tight = "_t-n";
export var titleIcon = "_t-b";
export var warn = "_t-q";